import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const CompanyInfoPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "General", "label": "axFormLayout.companyinfo.tabs.general", "order": 1, "groups": [{"groupId": "GroupName", "label": "axFormLayout.companyinfo.groups.general.groupname", "order": 1, "fields": ["name"]}, {"groupId": "Address", "label": "axFormLayout.companyinfo.groups.general.address", "order": 2, "fields": ["street", "zipcode", "city", "county", "state", "countryregionid"]}, {"groupId": "AddressDisplay", "label": "axFormLayout.companyinfo.groups.general.addressdisplay", "order": 3, "fields": ["address"]}, {"groupId": "General_MainFields", "label": "axFormLayout.companyinfo.groups.general.general_mainfields", "order": 4, "fields": ["addrformat"]}], "fields": []}, {"tabId": "TabCommunication", "label": "axFormLayout.companyinfo.tabs.tabcommunication", "order": 2, "groups": [{"groupId": "ContactInfo", "label": "axFormLayout.companyinfo.groups.tabcommunication.contactinfo", "order": 1, "fields": ["phone", "phonelocal", "cellularphone", "pager", "telefax", "email", "sms", "url", "telex"]}, {"groupId": "RegistrationNumbers", "label": "axFormLayout.companyinfo.groups.tabcommunication.registrationnumbers", "order": 2, "fields": ["regnum", "coregnum", "branchid", "dvrid", "upsnum", "intrastatcode", "activitycode", "suffix"]}], "fields": []}, {"tabId": "Various", "label": "axFormLayout.companyinfo.tabs.various", "order": 3, "groups": [{"groupId": "Currency", "label": "axFormLayout.companyinfo.groups.various.currency", "order": 1, "fields": ["currencyCode", "eurocurrencycode", "secondarycurrencycode"]}, {"groupId": "CompanyCurrencyConversion", "label": "axFormLayout.companyinfo.groups.various.companycurrencyconversion", "order": 2, "fields": ["conversiondate"]}, {"groupId": "BankAccounts", "label": "axFormLayout.companyinfo.groups.various.bankaccounts", "order": 3, "fields": ["bank", "giro"]}, {"groupId": "Languages", "label": "axFormLayout.companyinfo.groups.various.languages", "order": 4, "fields": ["languageid"]}, {"groupId": "SalesTax", "label": "axFormLayout.companyinfo.groups.various.salestax", "order": 5, "fields": ["vatnum", "vatnumbranchid", "importvatnum", "importvatnumbranchid", "taxrepresentative"]}, {"groupId": "PackagingMaterialFee", "label": "axFormLayout.companyinfo.groups.various.packagingmaterialfee", "order": 6, "fields": ["packmaterialfeelicensenum"]}, {"groupId": "Shipping", "label": "axFormLayout.companyinfo.groups.various.shipping", "order": 7, "fields": ["shippingcalendarid"]}], "fields": []}, {"tabId": "NL_BTL91", "label": "axFormLayout.companyinfo.tabs.nl_btl91", "order": 4, "groups": [{"groupId": "BTL91", "label": "axFormLayout.companyinfo.groups.nl_btl91.btl91", "order": 1, "fields": ["bankcentralbankpurposecode", "bankcentralbankpurposetext"]}], "fields": []}, {"tabId": "Tax1099", "label": "axFormLayout.companyinfo.tabs.tax1099", "order": 5, "groups": [{"groupId": "Misc1099", "label": "axFormLayout.companyinfo.groups.tax1099.misc1099", "order": 1, "fields": ["namecontrol", "bankacctusedfor1099"]}], "fields": []}];

  const baseColumns = [
    {
      key: "dataAreaId",
      label: "companyInfo.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "key",
      label: "companyInfo.key",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "number",
      filterType: "number"    },
    {
      key: "name",
      label: "companyInfo.name",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "address",
      label: "companyInfo.address",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "phone",
      label: "companyInfo.phone",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "telefax",
      label: "companyInfo.telefax",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "bank",
      label: "companyInfo.bank",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "giro",
      label: "companyInfo.giro",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "regnum",
      label: "companyInfo.regnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "coregnum",
      label: "companyInfo.coregnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "currencyCode",
      label: "companyInfo.currencyCode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "zipcode",
      label: "companyInfo.zipCode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "state",
      label: "companyInfo.state",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "county",
      label: "companyInfo.county",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "countryregionid",
      label: "companyInfo.countryregionid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "telex",
      label: "companyInfo.telex",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "url",
      label: "companyInfo.url",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "url"    },
    {
      key: "email",
      label: "companyInfo.email",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "email"    },
    {
      key: "cellularphone",
      label: "companyInfo.cellularphone",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "phonelocal",
      label: "companyInfo.phonelocal",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "phone"    },
    {
      key: "upsnum",
      label: "companyInfo.upsnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "namecontrol",
      label: "companyInfo.namecontrol",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "dvrid",
      label: "companyInfo.dvrid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "languageid",
      label: "companyInfo.languageid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "girocontract",
      label: "companyInfo.girocontract",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "girocontractaccount",
      label: "companyInfo.girocontractaccount",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "branchid",
      label: "companyInfo.branchid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "vatnumbranchid",
      label: "companyInfo.vatnumbranchid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "importvatnumbranchid",
      label: "companyInfo.importvatnumbranchid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "activitycode",
      label: "companyInfo.activitycode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "street",
      label: "companyInfo.street",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "city",
      label: "companyInfo.city",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "conversiondate",
      label: "companyInfo.conversiondate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "pager",
      label: "companyInfo.pager",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "sms",
      label: "companyInfo.sms",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "addrformat",
      label: "companyInfo.addrformat",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "bankcentralbankpurposecode",
      label: "companyInfo.bankcentralbankpurposecode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "bankcentralbankpurposetext",
      label: "companyInfo.bankcentralbankpurposetext",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "shippingcalendarid",
      label: "companyInfo.shippingcalendarid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "bankacctusedfor1099",
      label: "companyInfo.bankacctusedfor1099",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "modifieddate",
      label: "companyInfo.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "modifiedtime",
      label: "companyInfo.modifiedtime",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "modifiedby",
      label: "companyInfo.modifiedby",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "text"    },
    {
      key: "recversion",
      label: "companyInfo.recversion",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "recId",
      label: "companyInfo.recId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "delSyssignadmin",
      label: "companyInfo.delSyssignadmin",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "vatnum",
      label: "companyInfo.vatnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "importvatnum",
      label: "companyInfo.importvatnum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "delSyssignsendemail",
      label: "companyInfo.delSyssignsendemail",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "email"    },
    {
      key: "eurocurrencycode",
      label: "companyInfo.eurocurrencycode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "secondarycurrencycode",
      label: "companyInfo.secondarycurrencycode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "intrastatcode",
      label: "companyInfo.intrastatcode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "delRefzipcode",
      label: "companyInfo.delRefzipcode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "number",
      filterType: "number"    },
    {
      key: "packmaterialfeelicensenum",
      label: "companyInfo.packmaterialfeelicensenum",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "delCompanysiacode",
      label: "companyInfo.delCompanysiacode",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "delPaymitemcodeid",
      label: "companyInfo.delPaymitemcodeid",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "taxrepresentative",
      label: "companyInfo.taxrepresentative",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "vatnumTh",
      label: "companyInfo.vatnumTh",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "cucIt",
      label: "companyInfo.cucIt",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "suffix",
      label: "companyInfo.suffix",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: false,
    canEdit: true,
    canDelete: false
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="companyInfo"
      permissionPrefix="legacy.companyInfo"
      icon={faBuilding}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default CompanyInfoPageGen;